import { render } from "./BankTransferPayment.vue?vue&type=template&id=36e1a042&scoped=true&ts=true"
import script from "./BankTransferPayment.vue?vue&type=script&lang=ts"
export * from "./BankTransferPayment.vue?vue&type=script&lang=ts"

import "./BankTransferPayment.vue?vue&type=style&index=0&id=36e1a042&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e1a042"]])

export default __exports__